import { createLinkBubbleToolbar } from './link-bubble-toolbar.js';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { isForbidden } from './utils.js';
import './link-modal.js';
export class LinkPlugin {
    initEditor(editor) {
        this.editor = editor;
    }
    constructor(opt = {}) {
        this.name = 'link';
        this.priority = 60;
        this.spec = {
            type: 'mark',
            attrs: {
                href: {
                    parse: (node) => {
                        const href = node.getAttribute('href');
                        return isForbidden(href) ? false : href;
                    },
                    toDOMAttribute: (href) => ({ href }),
                },
                target: {
                    parse: (node) => node.hasAttribute('target')
                        ? node.getAttribute('target') || ''
                        : this.opt.defaultTarget,
                    toDOMAttribute: (target) => (target ? { target } : null),
                },
            },
            matchSelector: 'a[href]',
            toDOM: 'a',
            inclusive: false,
            group: 'g_importantMarks',
        };
        this.bubble = null;
        this.edit = () => {
            const t = this.editor.t.bind(this.editor);
            const modal = document.createElement('exeditor-link-modal');
            modal.t = t;
            modal.title = this.isActive() ? t('编辑链接') : t('添加链接');
            modal.text = this.getText();
            modal.link = this.getAttr('href');
            modal.target = this.getAttr('target');
            modal.addEventListener('submit', (event) => {
                const { detail } = event;
                // check if something is selected
                const { from, to } = this.getIntentRange();
                const hasContent = from !== to;
                const data = {
                    text: hasContent ? detail.text : detail.text || detail.link,
                    href: detail.link,
                    target: detail.target,
                };
                this.editor.focus();
                this.update(data);
            });
            modal.addEventListener('close', () => {
                document.body.removeChild(modal);
                this.editor.focus();
            });
            document.body.appendChild(modal);
        };
        this.isActive = () => this.editor.isActive(this);
        this.canApply = () => this.editor.selection().canToggleMark(this);
        this.opt = {
            defaultTarget: '',
            onCopy() { },
            ...opt,
        };
    }
    capabilities() {
        return {
            commands: {
                set: this.set.bind(this),
                edit: this.edit,
                update: this.update.bind(this),
                delete: this.delete.bind(this),
                isActive: this.isActive.bind(this),
                getText: this.getText.bind(this),
                getAttr: this.getAttr.bind(this),
            },
            shortcuts: {
                'Mod-k': this.edit,
            },
        };
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        btn.label = this.editor.t('链接');
        btn.shortcut = 'Mod-k';
        const icon = createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.linkIcon),
        });
        btn.addEventListener('click', this.edit, false);
        const setBtnStatus = () => {
            btn.active = this.isActive();
            btn.disabled = !this.canApply();
        };
        this.editor.on('idlechange', setBtnStatus);
        btn.appendChild(icon);
        return btn;
    }
    editView(node) {
        if (!this.bubble) {
            const bubble = createLinkBubbleToolbar(this.editor, this);
            document.body.appendChild(bubble);
            this.bubble = bubble;
            this.editor.on('beforedestroy', () => {
                document.body.removeChild(this.bubble);
                this.bubble = null;
            });
        }
        const elt = document.createElement('a');
        if (node.attrs.href) {
            elt.href = node.attrs.href;
        }
        if (node.attrs.target) {
            elt.target = node.attrs.target;
        }
        return {
            dom: elt,
            destroy: () => { },
        };
    }
    set(options) {
        return this.editor.execute((state, dispatch) => {
            const { schema } = state;
            const { text } = options;
            const node = schema.text(text || options.href, [
                schema.marks.link.create(options),
            ]);
            if (dispatch)
                dispatch(state.tr.replaceSelectionWith(node, false));
            return true;
        });
    }
    delete() {
        const { from, to } = this.getIntentRange();
        this.editor.removeMark(from, to, this);
    }
    update(options) {
        const { from, to } = this.getIntentRange();
        const oldText = this.getText();
        if (oldText === options.text) {
            this.editor.selection(from, to).addMark(this, options);
        }
        else {
            this.editor.selection(from, to);
            this.set(options);
        }
    }
    getText() {
        const { from, to } = this.getIntentRange();
        return this.editor.textBetween(from, to);
    }
    getAttr(attr) {
        const fallbackVal = attr === 'target' ? this.opt.defaultTarget : '';
        return (this.editor.selection().getMarkAttrs(this)[attr] || fallbackVal);
    }
    open() {
        window.open(this.getAttr('href'), '_blank', 'noopener noreferrer');
    }
    copy() {
        Promise.resolve()
            .then(() => {
            return navigator.clipboard.writeText(this.getAttr('href'));
        })
            .then(() => this.handleCopy(true), () => this.handleCopy(false));
    }
    handleCopy(isSuccess) {
        this.opt.onCopy(isSuccess);
    }
    getIntentRange() {
        let { from, to } = this.editor.selection();
        [from, to].forEach((pos) => {
            const range = this.editor.getMarkRange(pos, this);
            if (range) {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        });
        return { from, to };
    }
}
//# sourceMappingURL=index.js.map